import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import { PrismSelectInput } from '@mylighthouse/prism-ember';

const DEFAULT_PAGE_SIZE_OPTIONS = [100, 1000, 5000, 10000] as const;

interface GeneralDropdownsDropdownPageSizeSignature {
  Args: {
    onChange: (pageSizeOption: { label: string; value: number }) => void;
    options?: readonly number[];
    testId?: string;
    value: { label: string; value: number };
  };
}

export default class GeneralDropdownsDropdownPageSize extends Component<GeneralDropdownsDropdownPageSizeSignature> {
  @service declare intl: Services['intl'];

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get pageSizeOptions() {
    const options = this.args.options ?? DEFAULT_PAGE_SIZE_OPTIONS;
    return options.map((noOfRows) => ({
      value: noOfRows,
      label: this.intl.t('general.page_no_of_rows', {
        noOfRows: this.intl.formatNumber(noOfRows),
      }),
    }));
  }

  <template>
    <PrismSelectInput
      @isSmall={{true}}
      @onChange={{@onChange}}
      @options={{this.pageSizeOptions}}
      @value={{@value}}
      data-test-id={{if @testId @testId "dropdown-page-size"}}
    />
  </template>
}
